const config = {
  mapUrl: 'https://goo.gl/maps/3L8xtSRZC7wRfugT9',
  linkedInUrl: 'https://www.linkedin.com/company/heco-et-al',
  phone: '+45 41 18 00 23',
  email: 'slm@hecoetal.com',
};

export default config;